import HistoryActivity, { type GetHistory } from "@common/components/Activity/History";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

type Props = {
  cycleEndDate: string;
  getHistory: GetHistory;
  labelKeyMapper?: (labelKey: string) => string;
  style?: React.CSSProperties;
};
export const HistoryWidget = (props: Props) => {
  const i18n = useI18n();

  return (
    <HistoryActivity
      category="Network"
      className="affiliate_history_activity"
      dashboardKey="Affiliate"
      endDate={props.cycleEndDate}
      labelKeyMapper={props.labelKeyMapper}
      filter={i18n.activity}
      get={props.getHistory}
      noDataMessage={i18n.infoNoActivity}
      refreshKey={props.cycleEndDate}
      showLink={false}
      style={props.style}
    />
  );
};
